  
import React from 'react';
import "../styles/footer.css";

function Footer(){
  return (
    <footer>
      <p>&copy; 2025. Developed by John. All rights reserved</p>
      </footer>
  );
}

export default Footer;



